<template>
  <CRow>
   
    <CCol col="12" md="12">
    
<CRow>
<CCol col="6" md="7">
  <CCard>
 <CCardBody>     
 <CDataTable
          :items="speciesItem"
          :fields="fields"
          pagination
          clickable-rows
          hover
            table-filter
          items-per-page-select
          :items-per-page="10"
          @row-clicked="rowClicked"
          caption="Species"
          
        />

       </CCardBody>  
   </CCard>    
</CCol>

<CCol col="6" md="5">
          <CCard>
       
            <CForm >
<c-card-body>
                    
                          <CInput label="pregnancyFrom" name="liveWeightfrom" id="liveWeightfrom" required horizontal autocomplete="name" size="25" v-model="pregnancyFrom"   />

                    <CInput label="pregnancyTo" name="liveWeightto" id="liveWeightto" required horizontal autocomplete="name" v-model="pregnancyTo" />
                    <CInput label="Dry" name="dry" id="dry" required horizontal autocomplete="name" v-model="dry" />
                    <CInput label="S.P.Foode" name="s_p_fodder" id="s_p_fodder" required horizontal autocomplete="name"  v-model="s_p_fodder" />
                    <!-- <CInput label="DRY M" name="breedName" id="breedName" required horizontal autocomplete="name" v-model="s_p_fodder"/> -->
                     <CInput label="DRY M1" name="dryM1" id="dryM1" required horizontal autocomplete="name" v-model="dryM1"/>
                      <CInput label="DRY M2" name="dryM2" id="dryM2" required horizontal autocomplete="name" v-model="dryM2" />
    <CInput label="DRY M3" name="dryM3" id="dryM3" required horizontal autocomplete="name" v-model="dryM3" />
     <CInput label="Green Fodder" name="greenFodder" id="greenFodder" required horizontal autocomplete="name" v-model="greenFodder" />
              </c-card-body>    
                  </CForm>
        
            <CCardFooter>
          <CButton color="info" style="width:100px" v-if="addButton" @click="addSpecies">
            <CIcon name="cilPencil" />&nbsp;Add
          </CButton>&nbsp;
          <CButton color="success" style="width:100px" v-if="saveButton" @click="updateSpecies">
            <CIcon name="cilCheck" />&nbsp;Save
          </CButton>&nbsp;
          <CButton color="success" style="width:100px" v-if="EditsaveButton" @click="addSpecies">
            <CIcon name="cilCheck" />&nbsp;Save
          </CButton>&nbsp;
          <CButton color="danger" style="width:100px" v-if="deleteButton" @click="deleteSpecies">
            <CIcon name="cilXCircle" />&nbsp;Delete
          </CButton>&nbsp;
       
             <CButton
                    color="secondary"
                    style="width:100px"
                    v-if="cancelButton"
                    @click="Cancelspecies"
                  >
                    <CIcon name="cilWarning" />&nbsp;Cancel
                  </CButton>

                    <CButton
                    color="info"
                   
                    v-if="addnewButton"
                    @click="addnewspecies"
                  >
                    <CIcon name="cilPencil" />&nbsp;Add New
                  </CButton>
        </CCardFooter>
                </CCard>
</CCol>
</CRow>
             
            
            

        
    </CCol>
  </CRow>
</template>

<script>
import CTableWrapper from "../../../tables/Table";
import { APIService } from "../../../../apiservice.js";
import Swal from "sweetalert2";
export default {
  components: { CTableWrapper },

  data() {
    return {
      speciesItem:[],
      editSpecies:[],
      pregnancyFrom:"",
      pregnancyTo:"",
      dry:"",
  s_p_fodder: "",
  dryM1:"",
  dryM2:"",
  dryM3:"",
  greenFodder:"",
      addButton: true,
      saveButton: false,
      deleteButton: false,
      addnewButton:false,
      cancelButton:false,
      EditsaveButton:false,
      options: ["Option 1", "Option 2", "Option 3"],
      tabs: ["Body Weight", "Maintance","Pregnancy Month Wise "],
      fields: [
        {
          key: "pregnancyFrom",
          sortable: true
        },
        {
          key: "pregnancyTo",
          sortable: true
        },
        {
          key: "dry",
          sortable: true
        },
         {
          key: "s_p_fodder",
          sortable: true
        },
        //  {
        //   key: "dryM1",
        //   sortable: true
        // },
        //     {
        //   key: "dryM2",
        //   sortable: true
        // },
        //   {
        //   key: "dryM3",
        //   sortable: true
        // },
            {
          key: "greenFodder",
          sortable: true
        }
      ],
    //   items: [
    //     {
    //       isActive: true,
    //      Live_Weight_kg_From: "1",
    //       Live_Weight: "Murrah",
    //       Dry: "Buffalo",
    //          S_P_Foode: "1",
    //       DRY_M: "Murrah",
    //        DRY_M: "Buffalo",
    //        Green_Fodder: "Buffalo"
    //     },

       
    //   ],
    //  fields1: [
    //     {
    //       key: "Pregnancy_Days_From",
    //       sortable: true
    //     },
    //     {
    //       key: "Pregnancy_Days_To",
    //       sortable: true
    //     },
    //     {
    //       key: "Dry",
    //       sortable: true
    //     },
    //      {
    //       key: "S_P_Foode",
    //       sortable: true
    //     },
    //      {
    //       key: "DRY_M",
    //       sortable: true
    //     },
    //         {
    //       key: "DRY_M",
    //       sortable: true
    //     },
    //         {
    //       key: "Green_Fodder",
    //       sortable: true
    //     }
    //   ],
    //   items1: [
        
    //   ],
    //   fields2: [
    //     {
    //       key: "Milk_kg_From",
    //       sortable: true
    //     },
    //     {
    //       key: "Milk_Kg_To",
    //       sortable: true
    //     },
    //     {
    //       key: "Dry",
    //       sortable: true
    //     },
    //      {
    //       key: "S_P_Foode",
    //       sortable: true
    //     },
    //      {
    //       key: "DRY_M",
    //       sortable: true
    //     },
    //         {
    //       key: "DRY_M",
    //       sortable: true
    //     },
    //         {
    //       key: "Green_Fodder",
    //       sortable: true
    //     }
    //   ],
    //   items1: [
        
    //   ],
    };
  },
 methods: {
   getpregnancyList() {
      APIService.pregnancyList().then(res => {
        if (res.status == 200) {
          this.speciesItem = res.data;

           this.pregnancyFrom = this.speciesItem[0].pregnancyFrom;
      this.pregnancyTo = this.speciesItem[0].pregnancyTo;
      this.dry = this.speciesItem[0].dry;
       this.s_p_fodder = this.speciesItem[0].s_p_fodder;
      this.dryM1 = this.speciesItem[0].dryM1;
       this.dryM2 = this.speciesItem[0].dryM2;
        this.dryM3 = this.speciesItem[0].dryM3;
      this.greenFodder = this.speciesItem[0].greenFodder;
        }
      });
    },
    rowClicked(item, index, column, e) {
      console.log("edit item", item, index, column, e);

      this.editSpecies = item;
      this.pregnancyFrom = item.pregnancyFrom;
      this.pregnancyTo = item.pregnancyTo;
      this.dry = item.dry;
       this.s_p_fodder = item.s_p_fodder;
      this.dryM1 = item.dryM1;
       this.dryM2 = item.dryM2;
        this.dryM3 = item.dryM3;
      this.greenFodder = item.greenFodder;
      this.addButton = false;
      this.saveButton = true;
      this.deleteButton = true;
      this.cancelButton =false;
      this.addnewButton=true;
      this.EditsaveButton=false;
    },
      addnewspecies(){
          this.milkFrom="",
         this.milkTo="",
         this.dry="",
     this.s_p_fodder="",
     this.dryM1="",
     this.dryM2="",
     this.dryM3="",
     this.greenFodder="",
          this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton =true;
          this.addnewButton=false;
           this.EditsaveButton=true,
      this.getpregnancyList();
         
    },
Cancelspecies(){
         this.milkFrom="",
         this.milkTo="",
         this.dry="",
     this.s_p_fodder="",
     this.dryM1="",
     this.dryM2="",
     this.dryM3="",
     this.greenFodder="",
          this.addButton = true;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton =false;
          this.addnewButton=false;
           this.EditsaveButton=false,
         this.getpregnancyList();
    },
    
    addSpecies() {
      let pregnancyFrom = this.pregnancyFrom;
      let pregnancyTo = this.pregnancyTo;
       let dry = this.dry;
        let s_p_fodder = this.s_p_fodder;
      let dryM1 = this.dryM1;
       let dryM2 = this.dryM2;
        let dryM3 = this.dryM3;
       let greenFodder = this.greenFodder;
      let data = {
       pregnancyFrom,
        pregnancyTo,
        dry,
        s_p_fodder,
        dryM1,
        dryM2,
        dryM3,
        greenFodder
      };
      APIService.savePregnancy(data).then(res => {
        if (res.status == 200) {
         this.pregnancyFrom="",
         this.pregnancyTo="",
         this.dry="",
     this.s_p_fodder="",
     this.dryM1="",
     this.dryM2="",
     this.dryM3="",
     this.greenFodder="",
        this.getpregnancyList();
           Swal.fire({
  position: 'center',
  icon: 'success',
  title: 'Data Saved Successfully',
  showConfirmButton: false,
  timer: 2000
})
        }
      });
    },
    updateSpecies() {
        let id = this.editSpecies._id;
  let pregnancyFrom = this.pregnancyFrom;
      let pregnancyTo = this.pregnancyTo;
       let dry = this.dry;
        let s_p_fodder = this.s_p_fodder;
      let dryM1 = this.dryM1;
       let dryM2 = this.dryM2;
        let dryM3 = this.dryM3;
       let greenFodder = this.greenFodder;
      let value = {
         pregnancyFrom,
        pregnancyTo,
        dry,
        s_p_fodder,
        dryM1,
        dryM2,
        dryM3,
        greenFodder
      };
      let data = { id, value };
      APIService.pregnancyUpdate(data).then(res => {
        if (res.status == 200) {
       this.milkFrom="",
         this.milkTo="",
         this.dry="",
     this.s_p_fodder="",
     this.dryM1="",
     this.dryM2="",
     this.dryM3="",
     this.greenFodder="",
          this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
           this.cancelButton =false;
           this.addnewButton=true;
           this.getpregnancyList();
          Swal.fire({
  position: 'center',
  icon: 'success',
  title: 'Data Saved Successfully',
  showConfirmButton: false,
  timer: 2000
})
        }
      });
    },
    deleteSpecies() {
const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger'
  },
  buttonsStyling: false
})

swalWithBootstrapButtons.fire({
  title: 'Are you sure?',
  text: "You won't be able to revert this!",
  icon: 'warning',
  showCancelButton: true,
  confirmButtonText: 'Yes, delete it!',
  cancelButtonText: 'No, cancel!',
  reverseButtons: true
}).then((result) => {
  if (result.value) {
    swalWithBootstrapButtons.fire(
      'Deleted!',
      'Your file has been deleted.',
      'success'
    )
     this.delete();
  } else if (
    /* Read more about handling dismissals below */
    result.dismiss === Swal.DismissReason.cancel
  ) {
    swalWithBootstrapButtons.fire(
      'Cancelled',
      'Your imaginary file is safe :)',
      'error'
    )
  }
})



  },

delete(){

      let id = this.editSpecies._id;
      let data = { id };
      APIService.pregnancyDelete(data).then(res => {
        if (res.status == 200) {
      this.pregnancyFrom="",
         this.pregnancyTo="",
         this.dry="",
     this.s_p_fodder="",
     this.dryM1="",
     this.dryM2="",
     this.dryM3="",
     this.greenFodder="",
          this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
           this.cancelButton =false;
             this.addnewButton=true;
              this.EditsaveButton=false,
          this.getpregnancyList();
        }
      });
    }
  },
  created() {
    this.getpregnancyList();
  }
};
</script>

